import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Table,
  message,
  Tooltip,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ROW_GUTTER } from "constants/ThemeConstant";
import { useMyContext } from "Context/MyContextProvider";
import apiClient from "services/apiClient";

export const GetFlows = async () => {
  try {
    const response = await apiClient.get("messaging/flows");
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching flows:", error);
    throw error;
  }
};

const FlowList = () => {
  const { Permisson } = useMyContext();
  const [searchText, setSearchText] = useState("");
  const [flowsList, setFlowsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletingFlowId, setDeletingFlowId] = useState(null);
  const [tableHeight, setTableHeight] = useState(null);
  const [tableRef, setTableRef] = useState(null);

  useEffect(() => {
    const fetchFlows = async () => {
      setLoading(true);
      try {
        const flows = await GetFlows();
        setFlowsList(flows);
      } catch (error) {
        message.error("Failed to fetch flows. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFlows();
  }, []);

  const deleteFlow = async (flowId) => {
    try {
      setDeletingFlowId(flowId);
      await apiClient.delete(`messaging/flows/${flowId}`);
      message.success("Flow deleted successfully");
      setFlowsList((prev) => prev.filter((flow) => flow.id !== flowId));
    } catch (error) {
      console.error("Error deleting flow:", error);
      message.error("Failed to delete flow. Please try again later.");
    } finally {
      setDeletingFlowId(null);
    }
  };

  // Filter flows based on search text
  const filteredFlows = flowsList.filter(
    (flow) =>
      flow.name.toLowerCase().includes(searchText.toLowerCase()) ||
      (flow.description &&
        flow.description.toLowerCase().includes(searchText.toLowerCase()))
  );

  const tableColumns = [
    {
      title: "Flow Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <span>
          {/* <Tooltip title="Edit Flow">
                        <Link to={`/flows/edit/${record.id}`}>
                            <Button type="link" icon={<EditOutlined />} />
                        </Link>
                    </Tooltip> */}
          {/* {Permisson?.includes('Delete flows') && ( */}
          <Tooltip title="Delete Flow">
            <Popconfirm
              title="Delete this flow?"
              description="This action cannot be undone."
              onConfirm={() => deleteFlow(record.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button
                danger
                icon={<DeleteOutlined />}
                loading={deletingFlowId === record.id}
              />
            </Popconfirm>
          </Tooltip>
          {/* )} */}
        </span>
      ),
    },
  ];

  return (
    <Row align="top" gutter={ROW_GUTTER}>
      <Col xs={24} sm={24} md={24} lg={24}>
        <motion.div
          layout
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
        >
          <Card
            title={
              <>
                <Row justify="space-between" align="middle">
                  <Col xs={24} sm={24} md={12} lg={8}>
                    <h2>Flows</h2>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={16}>
                    <Row gutter={[16, 16]} justify="end" align="middle">
                      <Col xs={24} sm={12} md={10} lg={6}>
                        <Input
                          allowClear
                          className="p-2 rounded"
                          value={searchText}
                          suffix={<SearchOutlined />}
                          size="large"
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                      </Col>
                      {Permisson?.includes("Create flows") && (
                        <Col xs={12} sm={12} md={6} lg={4}>
                          <Link to="create-flow">
                            <Button type="primary" block>
                              <PlusOutlined />
                              <span>New Flow</span>
                            </Button>
                          </Link>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </>
            }
          >
            <Row align="middle">
              <Col xs={24} sm={24} md={24} lg={24}>
                <div className="table-responsive">
                  <Table
                    loading={loading}
                    columns={tableColumns}
                    dataSource={filteredFlows}
                    rowKey="id"
                    scroll={{ x: "max-content" }}
                    locale={{
                      emptyText: loading
                        ? "Loading flows..."
                        : "No flows found",
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Card>
        </motion.div>
      </Col>
    </Row>
  );
};

export default FlowList;
